module.exports = __webpack_public_path__ + "static/media/down_arrow.6b2400ee.svg";